/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

type ModalProps={
  openModal : boolean,
   children: React.ReactNode, 
  containerclass?: string,
   dialogclassName?: string,
   setOpenModal: (isVisible: boolean)=>void
}
export default function Modal({ openModal, setOpenModal, children, 
  containerclass, dialogclassName }: ModalProps) {

  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={openModal || false} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-100"
        initialFocus={cancelButtonRef}
        onClose={()=>{}}
        
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className={"fixed z-100 inset-0 overflow-y-auto "}>
          <div className={"flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0"}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={`relative w-full bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 md:max-w-lg sm:w-full sm:p-6 overflow-visible ${dialogclassName} `}>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
